import type { DealTabs } from '@makemydeal/dr-shared-types';
import ResidualField from './ResidualField.interstate';
import { useBaseResidualInputProps } from './hooks/useBaseResidualInputProps';

export const BaseResidualField = ({ tab }: { tab?: DealTabs }) => {
    const inputProps = useBaseResidualInputProps();

    return <ResidualField inputProps={inputProps} fieldType="baseResidual" tab={tab} />;
};

export default BaseResidualField;
